/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { TOC } from "@ember/component/template-only";
import templateOnly from "@ember/component/template-only";
import type { ComponentLike, WithBoundArgs as WBA } from "@glint/template";
import type { EmberChangeset } from "ember-changeset";
import type ConditionalRadioGroup from "ui-kit/components/changeset/conditional-radio-group";
import type Range from "ui-kit/components/changeset/range";
import type Input from "ui-kit/components/changeset/labeled-input";

export interface Signature {
  Args: {
    changeset: EmberChangeset;
    isReadOnly: boolean;
  };
  Blocks: {
    default: [
      {
        changeset: Signature["Args"]["changeset"];
        ConditionalRadioGroup: WBA<
          typeof ConditionalRadioGroup,
          "changeset" | "isReadOnly"
        >;
        Range: WBA<typeof Range, "changeset">;
        Input: WBA<typeof Input, "changeset" | "isReadOnly">;
        NumberInput: ComponentLike<{
          Element: HTMLDivElement;
          Args: {
            labelName?: string;
            type?: string;
            propertyName?: string;
            placeholder?: string;
            isMandatory?: boolean;
            min?: string | number;
            max?: string | number;
            isReadOnly?: boolean;
            moreInformation?: string;
          };
        }>;
        Date: ComponentLike<{
          isReadOnly?: boolean;
          labelName?: string;
          propertyName?: string;
          type?: string;
          isMandatory?: boolean;
          formatter?: unknown;
        }>;
        FieldsRadioGroup: ComponentLike<{
          title?: string;
          propertyName?: string;
        }>;
        AlignedFieldsRadioGroup: ComponentLike<{
          title?: string;
          propertyName?: string;
          subText?: string;
          isMandatory?: boolean;
          displaySubText?: boolean;
        }>;
        BasicRadioGroup: ComponentLike<{
          propertyName?: string;
          title?: string;
        }>;
        Dropdown: ComponentLike<{
          isMandatory?: boolean;
          placeholder?: string;
          translationKey?: string;
          changeset?: EmberChangeset;
          propertyName?: string;
          labelName?: string;
          multipleSelection?: boolean;
          allowAdditions?: boolean;
          onChangesetUpdate?: unknown;
          selectPlaceholder?: string;
          selected?: string;
          isReadOnly?: boolean;
        }>;
        TextArea: ComponentLike<{
          Element: HTMLTextAreaElement;
          Args: {
            displaySubText?: boolean;
            subText?: string;
            placeholder?: string;
            labelName?: string;
            propertyName?: string;
            rows?: number | string;
          };
        }>;
        Checkbox: ComponentLike<{
          labelName?: string;
          disabled?: boolean;
          payloadKey?: string;
          propertyName?: string;
          isReadOnly?: boolean;
        }>;
        FileUpload: ComponentLike<{
          payloadKey?: string;
          propertyName?: string;
          isMandatory?: boolean;
        }>;
        ActionButton: ComponentLike<{
          Element: HTMLButtonElement;
          Args: {
            propertyName?: string;
          };
        }>;
        SendMessage: ComponentLike<{
          Args: {
            propertyName?: string;
            willSendMessage?: boolean;
            defaultChatMessage?: string;
          };
        }>;
        Time: ComponentLike<{
          Args: {
            propertyName?: string;
            labelName?: string;
          };
        }>;
        Footer: ComponentLike;
        LabeledTextArea: ComponentLike<{
          Args: {
            displaySubText?: boolean;
            subText?: string;
            changeset?: EmberChangeset;
            propertyName?: string;
            labelName?: string;
            rows?: number;
          };
        }>;
        DateTime: ComponentLike<{
          Args: {
            propertyName?: string;
            labelName?: string;
          };
        }>;
      }
    ];
  };
}

const ForcProviderBase: TOC<Signature> = templateOnly();
export default ForcProviderBase;
